import React from 'react';
import ImageSlideWithProgress from 'src/molecules/Standard/Shared/ImageSlideWithProgress/ImageSlideWithProgress';
import useTapIntoMagicSlides from './useTapIntoMagic';
import {
  DesktopContentWrapper,
  MobileContent,
  MobileContentWrapper,
  TapIntoMagicContainer,
  TapIntoMagicText,
  TapIntoMagicWrapper,
} from './TapIntoMagic.styles';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import { GatsbyImage } from 'gatsby-plugin-image';

export interface TapIntoMagicProps {
  backgroundColor?: string;
}

const TapIntoMagic = ({ backgroundColor }: TapIntoMagicProps): JSX.Element => {
  const slides = useTapIntoMagicSlides();

  return (
    <TapIntoMagicWrapper backgroundColor={backgroundColor}>
      <TapIntoMagicContainer>
        <TapIntoMagicText>
          <Heading
            text='Tap into people magic to create a more engaged and profitable community'
            standardSize='3.375'
            align='center'
          />
        </TapIntoMagicText>
        <DesktopContentWrapper>
          <ImageSlideWithProgress
            slides={slides}
            slideDuration={5000}
            slideLayout='fullWidth'
          />
        </DesktopContentWrapper>
        <MobileContentWrapper>
          {slides.map((slide, index) => (
            <MobileContent key={index}>
              <GatsbyImage
                image={slide.image}
                alt={slide.title}
              />
              <Heading
                text={slide.title}
                standardSize='1.25'
                align='left'
              />
              <Paragraph
                text={slide.description}
                size='1'
                align='left'
              />
            </MobileContent>
          ))}
        </MobileContentWrapper>
      </TapIntoMagicContainer>
    </TapIntoMagicWrapper>
  );
};

export default TapIntoMagic;
